<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>Tree 树形控件技能库</h2>
      <p>展示菜单数据列表中使用的自定义 node 节点名称写法，后续可以继续扩展更多 tree 案例。</p>
    </div>

    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" :md="8" :lg="6">
        <CodeCard
          title="自定义 Node 节点"
          description="节点内分两行展示标题和路由地址。"
          :code-content="treeCode"
          code-label="Vue"
        >
          <div class="tree-demo">
            <el-input
              v-model.trim="treeKeyword"
              size="small"
              clearable
              placeholder="筛选菜单节点"
              class="tree-search"
            />

            <div class="tree-panel">
              <el-tree
                ref="menuTree"
                :data="treeData"
                :props="treeProps"
                node-key="id"
                highlight-current
                default-expand-all
                :expand-on-click-node="false"
                :filter-node-method="filterTreeNode"
                class="menu-tree"
              >
                <span slot-scope="{ data }" class="tree-node">
                  <span class="tree-node__title">{{ data.title }}</span>
                  <span class="tree-node__path">{{ data.path }}</span>
                </span>
              </el-tree>
            </div>

            <div class="tips-panel">
              <div class="tips-title">实现要点</div>
              <ul class="tips-list">
                <li>通过 `slot-scope="{ data }"` 拿到当前节点数据。</li>
                <li>节点内容拆成两行，主标题显示名称，副标题显示路由。</li>
                <li>配合 `filter-node-method` 实现本地筛选。</li>
                <li>设置 `expand-on-click-node=&quot;false&quot;`，避免点击节点时误触发展开收起。</li>
              </ul>
            </div>
          </div>
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'

function buildTreeCode() {
  return `<template>
  <el-tree
    ref="menuTree"
    :data="treeData"
    :props="treeProps"
    node-key="id"
    highlight-current
    default-expand-all
    :expand-on-click-node="false"
    :filter-node-method="filterTreeNode"
  >
    <span slot-scope="{ data }" class="tree-node">
      <span class="tree-node__title">{{ data.title }}</span>
      <span class="tree-node__path">{{ data.path }}</span>
    </span>
  </el-tree>
</template>

<script>
export default {
  data() {
    return {
      treeProps: {
        label: 'title',
        children: 'children'
      },
      treeData: []
    }
  },
  methods: {
    filterTreeNode(value, data) {
      if (!value) return true
      const keyword = String(value).toLowerCase()
      return [data.title, data.path].join(' ').toLowerCase().includes(keyword)
    }
  }
}
<\/script>

<style scoped>
.tree-node {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
  padding: 4px 0;
}

.tree-node__title {
  color: #1f2d3d;
  font-size: 15px;
  line-height: 1.4;
}

.tree-node__path {
  color: #7b8ba1;
  font-size: 13px;
  line-height: 1.4;
}
<\/style>`
}

export default {
  name: 'PcTree',
  components: {
    CodeCard
  },
  data() {
    return {
      treeKeyword: '',
      treeCode: buildTreeCode(),
      treeProps: {
        label: 'title',
        children: 'children'
      },
      treeData: [
        {
          id: '__all__',
          title: '全部',
          path: '/',
          children: [
            {
              id: 'home',
              title: '首页',
              path: '/home'
            },
            {
              id: 'ai',
              title: 'AI',
              path: '/ai',
              children: [
                {
                  id: 'ai-demo',
                  title: 'demo',
                  path: '/ai/demo'
                }
              ]
            },
            {
              id: 'form',
              title: '表单',
              path: '/form',
              children: [
                {
                  id: 'input',
                  title: 'Input 输入框',
                  path: '/form/input'
                },
                {
                  id: 'tree',
                  title: 'tree 树形控件',
                  path: '/form/tree'
                },
                {
                  id: 'select',
                  title: 'Select 选择框',
                  path: '/form/select'
                },
                {
                  id: 'date',
                  title: 'Date 日期选择器',
                  path: '/form/date'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  watch: {
    treeKeyword(value) {
      if (this.$refs.menuTree) {
        this.$refs.menuTree.filter(value)
      }
    }
  },
  methods: {
    filterTreeNode(value, data) {
      if (!value) return true
      const keyword = String(value).toLowerCase()
      return [data.title, data.path].join(' ').toLowerCase().includes(keyword)
    }
  }
}
</script>

<style scoped>
/* 全局 .skill-page / .page-header 样式已由 global.scss 提供 */

.tree-demo {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tree-search {
  width: 100%;
}

.tree-panel {
  height: 320px;
  padding: 10px 12px;
  border: 1px solid rgba(31, 45, 61, 0.06);
  border-radius: 10px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  overflow: auto;
}

.menu-tree {
  max-height: 560px;
  overflow: auto;
}

.menu-tree ::v-deep .el-tree-node__content {
  height: auto;
  min-height: 34px;
  align-items: flex-start;
  padding: 6px 0;
}

.menu-tree ::v-deep .el-tree-node__expand-icon {
  margin-top: 8px;
}

.menu-tree ::v-deep .el-tree-node__label {
  flex: 1;
  min-width: 0;
}

.tree-node {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 0;
  min-width: 0;
}

.tree-node__title {
  font-size: 14px;
  color: #303133;
  line-height: 1.2;
}

.tree-node__path {
  font-size: 12px;
  color: #909399;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tips-panel {
  padding: 14px 16px;
  border-radius: 10px;
  background: #f7faff;
  border: 1px solid #e4ebf5;
}

.tips-title {
  margin-bottom: 8px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.tips-list {
  margin: 0;
  padding-left: 18px;
  color: #606266;
  font-size: 13px;
  line-height: 1.8;
}
</style>
